module.exports = __webpack_public_path__ + "img/ybg-socket.6f6637c8.jpg";